declare global {
  interface Window {
    dataLayer: {
      // push(item: AnalyticsDataLayerItem): void;
      push(...items: AnalyticsDataLayerItem[]): void;
    };
  }
}

/**
 * OneApp KR DQ solution design 1.91 엑셀 참고
 * 해당 엑셀 2.1 시트에 있는 메트릭 포멧임
 */
export interface AnalyticsDataLayerItem {
  event: string;
  data_name?: string;
  data_action?: string;

  // page view only
  screen_name?: string;
  screen_class?: string;

  // custom dimensions
  user_agent?: string; //User's platform or browser - ('ios', 'android')
  user_location?: string; //Location information based on device location for users who have consented to the use of location information.If users have not consented to the use of location information, default location information should be sent. - ()"
  user_country?: string; //Name or code of the user's country - ('it', 'de')
  biometric_auth_set?: string; //Biometric auth settings - (true|false)
  user_owns_vehicle?: string; //If a user is a KIA car owner - (true|false)
  is_ev_member?: string; //If a user has an active EV membership - (true|false)
  vehicles_registered?: string; //Number of user's registered vehicles - (1,2,3)
  customer_id?: string; //Custom Dimension that collects the User ID that gets set when someone logs into the KIA website - ({kia customer id})
  repr_vehicle_nameplate?: string; //User's Represented Vehicle nameplate - (‘ev6’)
  repr_vehicle_type?: string; //User's Represented Vehicle type - (‘suv’, ‘hybrid’, ‘electric’, etc.)
  repr_vehicle_year?: string; //User's Represented Vehicle year - (‘2022’)
  repr_vehicle_trim?: string; //User's Represented Vehicle trim - (‘lx’)
  repr_vehicle_nickname?: string; //Nickname of the user's represented car - ('my fav car')
  repr_vehicle_ownership?: string; //Represented Vehicle ownership type - ('my car', 'shared')
  click_location?: string; //Location of the component a user is interacting with - (‘header navigation bar’, ‘footer sitemap’, etc.) <- 이거 이 요소가 어디 존재하느냐임
  click_text?: string; //Label of (text on) the menu component a user is interacting with - (‘promotions’, ‘configurator’, ‘all about kia’, etc.)
  component?: string; //Inteacted component's name - ('warning light information')
  component_current_position?: string; //Interacted component's position  - ('4')
  component_max_position?: string; //How many components are exposed on an App Screen  - ('18')
  component_content?: string; //Exposed contents - ('low tire pressure')
  log_in_status?: string; //Indicating if a user has logged in - (‘logged in’, ‘not logged in’)
  form_step?: string; //The value describes the step in all lead forms. Used with the events tracking form submissions that consist of several steps   - (‘start’, ‘submit’, ‘select car’, etc.)
  interaction_type?: string; //Interaction type. Used with the events tracking users interaction with app components - ('view details', 'click cta', ‘view order’, 'update settings' etc.)
  vehicle_nameplate?: string; //Vehicle nameplate - (‘ev6’)
  vehicle_type?: string; //Vehicle type - (‘suv’, ‘hybrid’, ‘electric’, etc.)
  vehicle_year?: string; //Vehicle year - (‘2022’)
  vehicle_trim?: string; //Vehicle trim - (‘lx’)
  vehicle_colour_exterior?: string; //Vehicle exterior colour - (‘lunar silver’)
  vehicle_colour_interior?: string; //Vehicle interior colour - (‘(wk) satin black’)
  vehicle_engine?: string; //Vehicle engine - (“rwd (electric, automatic) 168 kw”)
  vehicle_condition?: string; //‘used or ‘new’ - (‘used or ‘new’)
  vehicle_ownership_type?: string; //Vehicle ownership type - ('my car', 'shared')
  representative_car?: string; //If the car is labeled as a representative car - (true|false)
  search_type?: string; //Search type - ('location', 'charging station')
  search_term?: string; //Search keyword - ('starbucks')
  search_results?: string; //Search results availability - ('yes'|'no')
  schedule_type?: string; //Scheduled event type - ('maintenance reservation', 'calendar link schedule')
  banner_title?: string; //The title of the banner a user is interacting with - ('the new sorento')
  banner_position?: string; //The position of the banner a user is interacting with - ('home screen')
  banner_sequence?: string; //The sequence number of the banner a user is interacting with - (1,2,3...)
  product_name?: string; //KIA Connect Store product/service title - ('rspa 2')
  list_category?: string; //The 'store name' a product is associated with in "my cart", "my subscription", "my order", "my  subscription" lists - ('kia connect store', 'kia charge')
  app_name?: string; //Name of an app from 'Family app' section - ('wible drive')
  push_title?: string; //Title of the push notification opened - ('promotion')
  affiliate_membership?: string; //Name of the membership a user links in affiliate membership linking - ('gs&point', 'ok cashbag')
  payment_method?: string; //Selected payment method when paying with SSCharger - ('nfc', 'qr')
  workshop_id?: string; //Workshop ID - (‘abc123’)
  workshop_name?: string; //Workshop Name - ('capitol hyundai service center')
  charging_station_id?: string; //Charging Station ID - (‘abc123’)
  charging_station_name?: string; //Charging Station Name - ('chargepoint charging station')
  ev_charge_type?: string; //Charge type in the EV Charging section interactions events - ('ccs', 'chademo')
  ev_charge_station_name?: string; //Charge station name in the EV Charging section interactions events - ('charge station name')
  navigation_name?: string; //Name of the tab a user is interacting with in the Navigation bar - ('home', 'control', 'store')
  selected_period?: string; //User-selected year and month in the monthly filter - ({yyyy/mm})

  // custom metrics
  vehicle_price?: number; //Vehicle price. Float value type.  - (43567)
  product_price?: number; //Product price. Float value type.  - (43567)
  price_min?: number; //min price set in the Used cars and car booking form filter - (15463)
  price_max?: number; //max price set in the Used cars and car booking form filter - (50477)
  shared_with?: number; //Number of users sharing a vehicle - (2)
}

/**
 *
 * @param screenName - 페이지 명
 * @param [screenClass] - 페이지 url (default: window.location.href)
 */
export function emitPageView(screenName: string, screenClass?: string) {
  window.dataLayer.push({
    event: 'screen_view',
    screen_name: screenName,
    screen_class: screenClass || window.location.href,
  });
}

export function emitEventLog(item: AnalyticsDataLayerItem) {
  window.dataLayer.push(item);
}
